import React from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

function HandleCheckboxes({ unselectAllItems, uncheckAllItems }) {
  const handleUncheckAll = () => {
    if (typeof uncheckAllItems === "function") {
      const ok = window.confirm(
        "Confirmez-vous le décochage des articles validés en boutique ?"
      );
      if (ok) uncheckAllItems();
    }
  };

  const handleUnselectAll = () => {
    if (typeof unselectAllItems !== "function") return;
    const ok = window.confirm(
      "Confirmez-vous le décochage des articles choisis pour les courses ?"
    );
    if (ok) unselectAllItems();
  };

  return (
    <Form className='mb-2'>
      <Row className='g-2'>
        <Col xs={6} sm={6}>
          <Button
            variant='danger'
            onClick={handleUnselectAll}
            className={`btn-sm w-100`}
            aria-label='Décocher tous les articles sélectionnés'>
            Décocher choisis
          </Button>
        </Col>
        <Col xs={6} sm={6}>
          <Button
            variant='danger'
            onClick={handleUncheckAll}
            className={`btn-sm w-100`}
            aria-label='Décocher tous les articles validés'>
            Décocher faits
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default HandleCheckboxes;
